import styled from 'styled-components';

const IFrameWrapper = styled.div`
  iframe {
    border: none;
  }

  height: 100%;
`;

export { IFrameWrapper };
